import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P35-E1",
    audio: "img/FriendsPlus/Page34/Audio/audio-e3-p34.mp3",
    video: "Videos/e3.p34.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [{ url: "img/FriendsPlus/Page35/E1/1.jpg" }],
      [{ url: "img/FriendsPlus/Page34/E3/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page34/E3/5.jpg" },
        { url: "img/FriendsPlus/Page34/E3/6.jpg", audioUrl: "img/FriendsPlus/Page34/Audio/hinh1-e3-p34.mp3", },
        { url: "img/FriendsPlus/Page34/E3/7.jpg" },
        { url: "img/FriendsPlus/Page34/E3/8.jpg", audioUrl: "img/FriendsPlus/Page34/Audio/hinh2-e3-p34.mp3", },
        { url: "img/FriendsPlus/Page34/E3/9.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page34/E3/10.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page34/E3/11.jpg" },
        { url: "img/FriendsPlus/Page34/E3/12.jpg", audioUrl: "img/FriendsPlus/Page34/Audio/hinh3-e3-p34.mp3", },
        { url: "img/FriendsPlus/Page34/E3/13.jpg" },
        { url: "img/FriendsPlus/Page34/E3/14.jpg", audioUrl: "img/FriendsPlus/Page34/Audio/hinh4-e3-p34.mp3", },
        { url: "img/FriendsPlus/Page34/E3/15.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page34/E3/16.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page34/E3/17.jpg" },
        { url: "img/FriendsPlus/Page34/E3/18.jpg", audioUrl: "img/FriendsPlus/Page34/Audio/hinh5-e3-p34.mp3", },
        { url: "img/FriendsPlus/Page34/E3/19.jpg" },
        { url: "img/FriendsPlus/Page34/E3/20.jpg", audioUrl: "img/FriendsPlus/Page34/Audio/hinh6-e3-p34.mp3", },
        { url: "img/FriendsPlus/Page34/E3/21.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page34/E3/22.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P35-E2",
    audio: "img/FriendsPlus/Page35/Audio/audio-e2-p35.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page35/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/tieude-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page35/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page35/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh1-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/7.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh2-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/9.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/10.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh3-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/11.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/12.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh4-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/13.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page35/E2/14.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/15.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh1-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/16.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/17.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh2-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/18.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/19.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh3-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/20.jpg" },
        {
          url: "img/FriendsPlus/Page35/E2/21.jpg",
          audioUrl: "img/FriendsPlus/Page35/Audio/hinh4-e2-p35.mp3",
        },
        { url: "img/FriendsPlus/Page35/E2/22.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page35/E2/23.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P35-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page35/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P35-E4",
    audio: "",
    video: "",
    component: D1,
    exerciseKey: "img/FriendsPlus/Page35/E4/Key/answerKey.png",
    isAllowSubmit: false,
    questionImage: [
      [{ url: "img/FriendsPlus/Page35/E4/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page35/E4/2.jpg" },
        { url: "img/FriendsPlus/Page35/E4/3.jpg", input: true, answer: "doesn't like" },
        { url: "img/FriendsPlus/Page35/E4/4.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page35/E4/5.jpg" }],
      [
        // Column4
        { url: "img/FriendsPlus/Page35/E4/6.jpg" },
        { url: "img/FriendsPlus/Page35/E4/7.jpg", input: true, answer: "likes" },
        { url: "img/FriendsPlus/Page35/E4/8.jpg" },
        { url: "img/FriendsPlus/Page35/E4/9.jpg", input: true, answer: "doesn't like" },
        { url: "img/FriendsPlus/Page35/E4/10.jpg" },
      ],
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P35-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page35/E5/1.jpg" }]],
  },
};

export default json;
